// El saldo de la empresa, para los guards de las herramientas del lienzo —
// ADR-2026-09-16-las-herramientas-del-lienzo-abren-en-panel.
//
// La misma consulta que hacen el visor y los modos antes de cobrar (plan y créditos
// restantes), una sola vez acá en vez de una copia por panel. `restantes` en `null`
// significa que no se pudo saber: los guards dejan pasar, y es el backend el que cobra
// o rechaza (así funciona en el visor: "subscription check failed, allow anyway").

import { leerSaldo } from '../../../lib/saldo';
import { supabase } from '../../../lib/supabase';

export interface Saldo {
  plan: string | null;
  restantes: number | null;
  /** La empresa factura por marca y la marca activa no tiene plan propio. */
  sinPlanDeMarca?: boolean;
  /** La empresa factura por marca: el saldo es el de la marca activa. */
  facturaPorMarca?: boolean;
}

export type TipoDeLimite = 'free-trial-ended' | 'plan-limit-reached';

export async function consultarSaldo(companyId: string): Promise<Saldo> {
  try {
    // Lector único: el saldo de la marca activa si la empresa factura por marca.
    const s = await leerSaldo(companyId);
    // `plan` es el de la EMPRESA (lo usan los gates Pro/Ultra); el de la billetera de marca no.
    const { data } = await supabase.from('company_profiles').select('plan').eq('id_company', companyId).single();
    const plan = (data as { plan?: string | null } | null)?.plan ?? null;
    return { plan, restantes: s.disponibles, sinPlanDeMarca: s.sinPlanDeMarca, facturaPorMarca: s.facturaPorMarca };
  } catch {
    return { plan: null, restantes: null };
  }
}

/** Qué modal de límite corresponde: el del plan gratis, o el de tope de plan. */
export const tipoDeLimite = (plan: string | null | undefined): TipoDeLimite =>
  plan === 'gratis' ? 'free-trial-ended' : 'plan-limit-reached';
